"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_users__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "711bc1a7-8e44-4906-9a49-02890b309439"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131,140.93a153.85,153.85,0,0,1-31.29-3.2,7.25,7.25,0,0,1-5.53-8.93c5.86-22.9,21.65-33.58,37-33.58s30.74,10.69,36.53,33.6a7.25,7.25,0,0,1-5.53,8.9A153.85,153.85,0,0,1,131,140.93Zm22.9-68.68a23,23,0,1,0-23,23A23,23,0,0,0,153.87,72.25Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "22c34e4a-05c4-4d65-82bd-44127820f0d9",
    x1: 90.61,
    y1: 75.15,
    x2: 168.98,
    y2: 153.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "6797dac5-cca8-4876-8393-d4a3d3201094",
    "data-name": "User_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "17f7fa32-8392-43ec-9b87-ab203fa5f8a1",
    "data-name": "<Pfad>",
    cx: 130.89,
    cy: 72.25,
    r: 22.98,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "167ba1a8-bace-4dc8-899e-b294fbd7c419",
    "data-name": "<Pfad>",
    d: "M162.12,137.73a7.25,7.25,0,0,0,5.53-8.9c-5.79-22.91-21.22-33.6-36.53-33.6s-31.1,10.68-37,33.58a7.25,7.25,0,0,0,5.53,8.93,153.85,153.85,0,0,0,31.29,3.2A153.85,153.85,0,0,0,162.12,137.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0f111fb6-07f2-42cb-b52a-387a83f17e12",
    "data-name": "<Pfad>",
    d: "M161.74,137.73a7.25,7.25,0,0,0,5.53-8.9c-5.79-22.91-21.22-33.6-36.53-33.6s-31.1,10.68-37,33.58a7.25,7.25,0,0,0,5.53,8.93,153.85,153.85,0,0,0,31.29,3.2A153.85,153.85,0,0,0,161.74,137.73Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "8ccc460e-4887-43b1-9e5e-8ad370a0d237",
    "data-name": "<Pfad>",
    cx: 74.05,
    cy: 63.63,
    r: 31.35,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "2b6da67c-bd76-4979-b4fd-f0362da6b11a",
    "data-name": "<Pfad>",
    cx: 130.52,
    cy: 72.25,
    r: 22.98,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#711bc1a7-8e44-4906-9a49-02890b309439)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "123.5 144 100.5 118.49 108.26 57.5 186.97 135.53 123.5 144",
    opacity: 0.2,
    fill: "url(#22c34e4a-05c4-4d65-82bd-44127820f0d9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a9aca3a6-6993-46cc-95de-fb721dc9f704",
    "data-name": "<Pfad>",
    d: "M116.64,153a9.89,9.89,0,0,0,7.55-12.15C116.29,109.56,95.25,95,74.35,95s-42.43,14.58-50.43,45.81A9.89,9.89,0,0,0,31.46,153a209.9,209.9,0,0,0,42.68,4.37A209.9,209.9,0,0,0,116.64,153Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.71,94.07a23,23,0,0,0,30.16-21.82c0-.34,0-.67,0-1a23,23,0,0,1-45.9,0c0,.33,0,.66,0,1A23,23,0,0,0,123.71,94.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8,129.61a7.22,7.22,0,0,1-5.68,6.12,153.87,153.87,0,0,1-31.15,3.2c-2.33,0-4.58-.06-6.79-.16l-.55,0c.19.67.37,1.34.55,2v.05a10.07,10.07,0,0,1,.25,1.47,9.94,9.94,0,0,0,0-1.51c2.12.09,4.27.15,6.49.15a153.87,153.87,0,0,0,31.15-3.2A7.24,7.24,0,0,0,167.8,129.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.66,93.83a31.35,31.35,0,0,0,39.73-30.21c0-.34,0-.67,0-1a31.34,31.34,0,0,1-62.65,0c0,.33,0,.66,0,1A31.35,31.35,0,0,0,65.66,93.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.64,151a209.89,209.89,0,0,1-42.5,4.37A209.9,209.9,0,0,1,31.46,151a9.85,9.85,0,0,1-7.79-8.68A9.87,9.87,0,0,0,31.46,153a209.9,209.9,0,0,0,42.68,4.37,209.89,209.89,0,0,0,42.5-4.37,9.87,9.87,0,0,0,7.79-10.68A9.85,9.85,0,0,1,116.64,151Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "users-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "5dfd20d8-b5b3-4e9f-af30-aa32bd7d02f2",
    "data-name": "Users_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "55001e2c-7113-4256-bc9c-51c1cff29df8",
    "data-name": "User_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#6797dac5-cca8-4876-8393-d4a3d3201094"
  })));
}

var _default = ic_users__dark;
exports.default = _default;